import React, { useEffect } from "react";
import styled from "@emotion/styled/macro";
import { 
    Grid2 as Grid,
    Typography,
    Slide
} from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Markdown from "react-markdown";
import CONTENT from './content';

const StyledMarkdown = styled(Markdown)`
    font-family: poppins;
    margin: 0 20%;
`;

const StyledGridContainer = styled(Grid)`
    height: 100%;
    align-items: center;
    font-family: poppins;
    min-width: 200px;
    margin: 1vh auto;
    margin-bottom: 10vh;
`;

const StyledAboutSiteHeading = styled(Typography)`
    font-family: poppins;
    text-align: center;
    margin-top: 3vh;
    margin-bottom: 5vh;
    pointer-events: none;
`;


const AboutSite = () => {
    let history = useHistory();
    useEffect(() => {
        if(history.action !== "POP"){
            window.scrollTo({
                top: 0
            });
        }
    }, [history]);

    return (
        <Slide direction="up" in mountOnEnter unmountOnExit timeout={400}>
               <StyledGridContainer container>
                <Grid item size={{xs: 12, md: 12}}>
                    <StyledAboutSiteHeading variant="h3"> About this site </StyledAboutSiteHeading>
                </Grid>
                <Grid item size={{xs: 12, md: 12}}>
                    <StyledMarkdown>
                        { CONTENT.PAGE_CONTENT }
                    </StyledMarkdown>
                </Grid>
            </StyledGridContainer>
         </Slide>
    );
}

export default AboutSite;